import React from 'react';
import { Stack, Text } from '@mantine/core';
import { EventDate } from './Events.date';
import dayjs from 'dayjs';
import { DayjsFormat } from '@/helpers';

export const EmptyList: React.FC<{
  eventDate: string;
  startDate?: string;
  endDate?: string;
}> = ({ eventDate, startDate, endDate }) => {
  return (
    <Stack gap="xs" pb="md" pr="md">
      <EventDate eventDate={eventDate} />
      <Text ta="center">
        {startDate && endDate ? (
          <>
            No events found between{' '}
            <Text span fw="bold">
              {dayjs(startDate).format(DayjsFormat.SHORT_DATE)}
            </Text>{' '}
            and{' '}
            <Text span fw="bold">
              {dayjs(endDate).format(DayjsFormat.SHORT_DATE)}
            </Text>{' '}
            for the selected filters.
          </>
        ) : (
          `No events found.`
        )}
      </Text>
    </Stack>
  );
};
